import React, { createContext, useContext, useRef, useEffect, useCallback } from 'react';

// The context is intentionally exported alongside its provider and hitbox.
// eslint-disable-next-line react-refresh/only-export-components
export const PhysicsContext = createContext({
  registerHitbox: () => {},
  unregisterHitbox: () => {},
  applyForce: () => {},
});

export const PhysicsProvider = ({ children }) => {
  const hitboxes = useRef(new Map());
  const forceQueue = useRef([]);

  const registerHitbox = useCallback((id, getRect, colorTheme) => {
    hitboxes.current.set(id, { getRect, colorTheme }); 
  }, []);

  const unregisterHitbox = useCallback((id) => {
    hitboxes.current.delete(id);
  }, []);

  const applyForce = useCallback((x, y, strength) => {
     forceQueue.current.push({ x, y, strength });
  }, []);

  return (
    <PhysicsContext.Provider value={{ registerHitbox, unregisterHitbox, applyForce, hitboxes }}>
      {children}
    </PhysicsContext.Provider>
  );
};

export const PaintHitbox = ({ children, id, className, absorbColor = '#FF1E90' }) => {
  const { registerHitbox, unregisterHitbox } = useContext(PhysicsContext);
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;
    const getRect = () => { if(!ref.current) return null; return ref.current.getBoundingClientRect(); };
    registerHitbox(id, getRect, absorbColor); 
    return () => unregisterHitbox(id);
  }, [id, registerHitbox, unregisterHitbox, absorbColor]);

  return (
    <div ref={ref} className={`relative inline-block w-fit ${className || ''}`}>
       {children}
    </div>
  );
};

 
